<template>
    <!-- 工人月详情 -->
    <div class="rzy-page">
        <el-button type="primary" @click="utils.printPage()">打印</el-button>

        <div style="margin-top: 10px; margin-bottom: 10px; margin-left: 20px;">
            {{this.yearDisplay}}年{{this.monthDisplay}}月 {{monthDetails.username}}
            {{monthDetails.roleDisplay}}&nbsp;&nbsp;&nbsp;&nbsp;总计{{monthDetails.sumHour}}小时
        </div>

        <el-table :data="monthDetails.dailyDataList" :header-cell-style="{'text-align':'center'}"
            id="workerMonthDetailsTable" :cell-style="{'text-align':'center','padding':'0px'}" border stripe
            max-height="600">
            <el-table-column label="日期/机台">
                <template slot-scope="data">
                    <el-link type="primary" @click="toDailyDetails(data)">{{data.row.dateDisplay}}</el-link>
                </template>
            </el-table-column>

            <!-- hongmj: 要求强制换行 sta -->
            <!-- <el-table-column v-for="(m) in machines" :key="m" :label="'机台'+m" :prop="m" /> -->
            <el-table-column v-for="(m) in machines" :key="m" :label="'机台'+m" :prop="m">
                <template slot-scope="scope">
                    <span v-html="scope.row[m]"></span>
                </template>
            </el-table-column>
            <!-- hongmj: 要求强制换行 end -->

            <el-table-column label="总工时" prop="sumDayHour" />

            <el-table-column label="有效工时" prop="validTime" />
            <el-table-column label="开机率" prop="poweronRate" />
        </el-table>

    </div>
</template>

<script>
    import api from '@/api/factory/statistics/worker'
    export default {
        data() {
            return {
                machines: ['37', '38'],
                monthDetails: {
                    workerId: '',
                    username: '', // 员工姓名
                    cardNumber: '', // 卡号
                    yearDisplay: '', // 显示年
                    monthDisplay: '', // 显示月
                    role: '', // 角色
                    roleDisplay: '', // 显示角色名称
                    sumHour: '', // 本月总工时
                    dailyDataList: [] // 每天的数据
                }
            }
        },
        methods: {
            // 判断角色是否为挡车工,因为挡车工的工时统计逻辑与其余工种有所差异
            isDangChe(role = '') {
                const realRole = role || this.monthDetails.role
                try {
                    return Number(realRole) === this.$enum.roleObj.dangche.value
                } catch (err) {}
            },
            // 获取工人一个月的打卡记录，开始时间为月份第一天的0点，结束时间为月份最后一天的24点
            getWorkerMonthDetails() {
                // 取 "挡车工报表" 传递来的 各种参数
                const role = this.$route.params.role
                const workerId = this.$route.params.id
                const startTime = this.firstTimeForMonth
                const endTime = this.lastTimeForMonth
                //
                api.getDetails({
                    role,
                    workerId,
                    startTime,
                    endTime
                }).then(res => {
                    if (this.isDangChe(role)) {
                        this.calculateMachine(res.data)
                        this.monthDetails = this.formatDangChe(res.data)
                    } else {
                        this.calculateMachine(res.data)
                        this.monthDetails = this.formatDangChe(res.data)
                    }
                })
            },

            // 计算机台信息
            calculateMachine(data) {
                const groupByMachine = this._.groupBy(data, (info) => {
                    return info.machineNumber
                })
                const machines = Object.keys(groupByMachine)
                // console.log(machines)
                this.machines = machines
            },

            // 格式化挡车工月份的打卡记录
            formatDangChe(data) {
                // 先把打卡数据  按日期 分组
                var groupByDaily = this._.groupBy(data, (info) => {
                    return new Date(info.startTime).getDate()
                })
                var dailyData = []
                const monthDay = this._.range(0, this.lastDate, 0) // 1天工时统计
                for (const d in monthDay) {
                    dailyData[d] = {
                        dateDisplay: (Number(d) + 1).toString() + '号',
                        sumDayHour: 0
                    }
                }
                // console.log(dailyData)
                var sum = 0 // 月总工时
                for (var date in groupByDaily) {
                    var oneDay = groupByDaily[date] // 取出1天的数据
                    // console.log('oneday', oneDay)
                    var workingHour = this.computeWorkingHour(oneDay) // 计算1天的总工时
                    // 如果在html加上小时，- - 和空的都会有
                    dailyData[date - 1].dateDisplay = (Number(date)).toString() + '号'
                    dailyData[date - 1].sumDayHour = `${workingHour}小时`
                    //追加有效工时--sta
                    var m_validTime = this.computeValidTime(oneDay) // 计算1天的有效工时
                    dailyData[date - 1].validTime = `${m_validTime}小时`

                    dailyData[date - 1].poweronRate = (workingHour == 0) ? '0%' :
                        (m_validTime / workingHour * 100).toFixed(2) + '%'
                    //追加有效工时--end
                    sum += Number(workingHour)
                    oneDay.forEach(j => {
                        dailyData[date - 1][j.machineNumber] = this.computeMachineWorkingHour(j) // 计算1天某个机台的工时
                    })
                }
                // console.log(dailyData)
                // console.log('data[0].role=', data[0].role)
                const formatObj = {
                    workerId: data[0].workerId,
                    username: data[0].username,
                    cardNumber: data[0].cardNumber,
                    role: data[0].role, // 小心这个role, pantou=1, dangche=2, chuansha=4
                    roleDisplay: this.$enum.roleArr[this.utils.formatEnum(data[0].role)[0]],
                    sumHour: `${sum.toFixed(2)}`,
                    dailyDataList: dailyData
                }
                return formatObj
            },
            //hongmj: 计算某个机台的工时
            computeMachineWorkingHour(m) {
                //250902 hcy说直接用totalTime -sta
                // let m_sumTime = this.utils.milliToHour(m.endTime - m.startTime)
                let m_sumTime = (m.totalTime / 3600).toFixed(2) //秒转小时
                //250902 hcy说直接用totalTime -sta
                let m_validTime = (m.validTime / 3600).toFixed(2) //秒转小时
                let m_poweronRate = (m_sumTime == 0) ? 0 : (m_validTime / m_sumTime * 100).toFixed(2) //开机率?

                // 250925 hongmj: 要求强制换行
                return m_sumTime + '小时<br>(' + m_poweronRate + '%)'
            },
            // 挡车工工时计算逻辑,一天中可能有多次上班 早班，夜班，故将工时计算逻辑抽出。
            computeWorkingHour(oneDay) {
                var sumTime = 0
                oneDay.forEach(item => {
                    //250902 hcy说直接用totalTime -sta
                    // var tempResult = this.utils.milliToHour(item.endTime - item.startTime)
                    var tempResult = (item.totalTime / 3600).toFixed(2) //秒转小时
                    //250902 hcy说直接用totalTime -end

                    // console.log('tempResult=', tempResult)
                    sumTime += Number(tempResult)
                })
                // console.log('sumTime=', sumTime)
                return sumTime.toFixed(2)
            },

            //追加有效工时--sta
            //计算1天中的有效工时
            computeValidTime(oneDay) {
                var sumTime = 0
                oneDay.forEach(item => {
                    sumTime += item.validTime //validTime是秒
                })
                // console.log('sumTime=', sumTime)
                return (sumTime / 3600).toFixed(2)
            },
            //追加有效工时--end

            // 点击日历中的一天，就跳转至某天的详情
            toDailyDetails(data) {
                var myTime = this.firstTimeForMonth // 初始化为1日
                // 1日 + 86400000(=1000ms *60*60*24) = 2日
                myTime = myTime + 86400000 * data.$index
                if (this.isDangChe()) {
                    if (data.row.sumDayHour !== '0') {
                        this.$router.push({
                            path: `/statistics/workerDetails/${this.monthDetails.role}/${this.monthDetails.workerId}/${myTime}`
                        })
                    }
                } else {
                    // TODO
                }
            }
        },
        // 页面创建时被调用
        created() {
            const time = this.$route.params.time // 取 "挡车工报表" 传递来的时间
            this.firstTimeForMonth = this.utils.getFirstTimeByMonth(time)
            this.lastTimeForMonth = this.utils.getLastTimeByMonth(time)
            this.currentMonth = this.firstTimeForMonth
            this.lastDate = new Date(this.lastTimeForMonth).getDate() // 本月最后一天，如 31
            // 显示 首行的年月 + 总工时
            var selectMonth = new Date(this.firstTimeForMonth)
            this.yearDisplay = selectMonth.getFullYear() // 显示年
            this.monthDisplay = selectMonth.getMonth() + 1 // 显示月
            //
            this.getWorkerMonthDetails() // 获取打卡记录
        }
    }
</script>

<style lang="scss" scoped>

</style>